import drawerActions from './actions'

const initialState = {
    drawerVisibility: false,
    drawerType: '',
    drawerProps: {},
    isAskToClose: false,
}

export default function drawerReducer(state = initialState, action) {
    switch (action.type) {
        case drawerActions.SHOW_DRAWER:
            return {
                drawerVisibility: true,
                drawerType: action.payload.drawerType,
                drawerProps: action.payload.drawerProps,
            }
        case drawerActions.HIDE_DRAWER:
            return {
                ...state,
                drawerVisibility: false,
            }
        case drawerActions.ASTK_TO_CLOSE:
            return {
                ...state,
                isAskToClose: action.payload.bool,
            }
        default:
            return state
    }
}
